import Vue from 'vue'
import Router from 'vue-router'

const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

export const constRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    name: 'Layout',
    component: () => import('../views/Layout.vue'),
    redirect: '/user',
    children: [
    {
      path: 'user',
      name: 'User',
      component: () => import('../views/user/User.vue'),
      meta: {
        title: 'User',
        icon: '',
      },
    },
    {
      path: 'user/detail',
      name: 'UserDetail',
      component: () => import('../views/user/Userdetail.vue'),
      meta: {
        title: 'UserDetail',
        icon: '',
      },
    },
    {
      path: 'shop',
      name: 'Shop',
      component: () => import('../views/shop/Shop.vue'),
      meta: {
        title: 'Shop',
        icon: '',
      },
    },
    {
      path: 'shop/detail',
      name: 'ShopDetail',
      component: () => import('../views/shop/Shopdetail.vue'),
      meta: {
        title: 'ShopDetail',
        icon: '',
      },
    },
    {
      path: 'gift',
      name: 'Gift',
      component: () => import('../views/gift/Gift.vue'),
      meta: {
        title: 'Gift',
        icon: '',
      },
    },
    {
      path: 'gift/detail',
      name: 'GiftDetail',
      component: () => import('../views/gift/Giftdetail.vue'),
      meta: {
        title: 'GiftDetail',
        icon: '',
      },
    },
    {
      path: 'acti',
      name: 'Acti',
      component: () => import('../views/acti/Acti.vue'),
      meta: {
        title: 'Acti',
        icon: '',
      },
    },
    {
      path: 'acti/detail',
      name: 'Actidetail',
      component: () => import('../views/acti/Actidetail.vue'),
      meta: {
        title: 'Actidetail',
        icon: '',
      },
    },
    ]
  },
]

// 权限页面：受保护页面，要求用户登录并拥有访问权限的角色才能访问
export const asyncRoutes = [
  {
    path: '/user',
    name: 'User',
    component: () => import('../views/user/User.vue'),
    meta: {
      title: 'User',
      icon: ''
    },
  }
]

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: constRoutes
})


